/**
 * Streak-flame: the three flame families stacked — fire-flame big at the
 * back, flame in the middle, flame-silhouette small in front — centered
 * and baseline-seated, drawn as outlines. Progress plays the shared fire
 * motion on every layer, with sparkles off the big back flame (see
 * StreakFlameBase and fireMotion.js).
 *
 * Color slots: 0 the big back flame, 1 the middle one, 2 the front one.
 */import*as React from"react";import StreakFlameBase from"web/shared/icons/glyphs/StreakFlameBase";import{jsx as _jsx}from"react/jsx-runtime";function StreakFlameGlyph(props){return/*#__PURE__*/_jsx(StreakFlameBase,{progress:props.progress,colors:props.colors,filled:false});}export default StreakFlameGlyph;